import { VStack } from "@chakra-ui/react"
import React from "react"
import { GenerateUserLocationRecordsReportForm } from "../../../forms"

export const GenerateUserLocationRecordsReport: React.FC = () => {
	return (
		<VStack w="full" spacing={6}>
			<GenerateUserLocationRecordsReportForm />
		</VStack>
	)
}
